import { hasValue } from "../../general-helpers";

export const getRequestHeaders = (endpointModel = {}, bearer = '') => {
    let requestHeaders = {};

    if(!hasValue(endpointModel)){
        return requestHeaders;
    }

    const { requestHeaders: { accept, contentType } } = endpointModel;

    if(hasValue(accept)){
        requestHeaders.accept = accept;
    }

    if(hasValue(contentType)){
        requestHeaders['content-type'] = contentType;
    }

    if(hasValue(bearer)){
        requestHeaders.authorization = `Bearer ${bearer}`;
    }

    return requestHeaders;
};

export const getRequestOptions = (endpointModel = {}, bearer = '') => {
    let options = {
        method: 'get'
    }

    const headers = getRequestHeaders(endpointModel, bearer);

    if(hasValue(headers)){
        options.headers = headers;
    }

    return options;
}